<div class="px-4 px-md-5 px-xxl-4">
  <div class="content-section">
    <form [formGroup]="contactForm">
      <div class="d-flex flex-column flex-lg-row mt-5 content-inputs">
        <div
          class="d-flex flex-column sp-between content-left w-100">
          <div>
            <div class="mb-3">
              <span class="text-white fs-1 fw-extrabold">{{contact.title}}</span>
            </div>
            <div>
              <span class="fw-regular fs-5 text-white">{{contact.description}}</span>
            </div>
            <div class="d-none d-lg-block">
              <br><br><br>
            </div>
            <div class="d-flex sp-between mt-5 mt-lg-0">
              <div class="d-flex al-center">
                <img [src]="contact.email.icon" class="me-3" alt="">
                <span class="fw-regular text-white">{{contact.email.name}}</span>
              </div>
              <div class="d-flex">
                <a href="https://www.instagram.com/diutinglobal/" target="_blank">
                  <img src="assets/svg/instagram.svg" class="me-4" width="36" alt="">
                </a>
                <a href="https://www.facebook.com/DiutinGlobal" target="_blank">
                  <img src="assets/svg/facebook.svg" width="36" alt="">
                </a>
              </div>
            </div>
          </div>
          <div class="text-center d-none d-lg-block">
            <img src="assets/images/contact-image.webp" alt="">
          </div>
        </div>
        <div class="w-100 content-right d-flex flex-column sp-between">
          <div>
            <div class="mb-2">
              <span class="text-danger">{{textError}}</span>
            </div>
            <div class="d-flex flex-column flex-sm-row flex-lg-column flex-xl-row content-inputs mb-5">
              <div class="w-100">
                <div class="mb-2">
                  <span class="fw-semibold">{{contact.textfields[0].label}} (<strong class="text-danger">*</strong>)</span>
                </div>
                <input class="w-100 border-0 border-bottom fw-semibold" formControlName="fullname"
                  [placeholder]="contact.textfields[0].placeholder">
              </div>
              <div class="w-100">
                <div class="mb-2">
                  <span class="fw-semibold">{{contact.textfields[1].label}} (<strong class="text-danger">*</strong>)</span>
                </div>
                <input class="w-100 border-0 border-bottom fw-semibold" formControlName="email"
                  [placeholder]="contact.textfields[1].placeholder">
              </div>
            </div>
            <div class="d-flex flex-column flex-sm-row flex-lg-column flex-xl-row content-inputs mb-5">
              <div class="w-100">
                <div class="mb-2">
                  <span class="fw-semibold">{{contact.textfields[2].label}} (<strong class="text-danger">*</strong>)</span>
                </div>
                <input class="w-100 border-0 border-bottom fw-semibold" formControlName="country"
                  [placeholder]="contact.textfields[2].placeholder">
              </div>
              <div class="w-100">
                <div class="mb-2">
                  <span class="fw-semibold">{{contact.textfields[3].label}} (<strong class="text-danger">*</strong>)</span>
                </div>
                <input class="w-100 border-0 border-bottom fw-semibold" formControlName="city"
                  [placeholder]="contact.textfields[3].placeholder">
              </div>
            </div>
            <div class="d-flex flex-column flex-sm-row flex-lg-column flex-xl-row content-inputs mb-5">
              <div class="w-100">
                <div class="mb-2">
                  <span class="fw-semibold">{{contact.textfields[5].label}} (<strong class="text-danger">*</strong>)</span>
                </div>
                <input class="w-100 border-0 border-bottom fw-semibold" formControlName="phone"
                  [placeholder]="contact.textfields[5].placeholder">
              </div>
              <div class="w-100"></div>
            </div>
            <div class="d-flex content-inputs mb-4">
              <div class="w-100">
                <div class="mb-2">
                  <span class="fw-semibold">{{contact.textfields[4].label}} (<strong class="text-danger">*</strong>)</span>
                </div>
                <textarea class="w-100 border-0 border-bottom fw-semibold" formControlName="request" rows="6"
                  [placeholder]="contact.textfields[4].placeholder"></textarea>
              </div>
            </div>
          </div>
          <div>
            <hr class="text-blue border-2 d-none d-lg-block">
            <div class="d-flex sp-end">
              <div class="btn-send bg-blue w-100 d-flex al-center sp-center pointer" (click)="sendConsult()">
                <span class="text-white fw-medium fs-4">{{contact.action}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br><br><br><br>
    </form>
  </div>
</div>